module.exports = __webpack_public_path__ + "img/Icons-Company profile non-photo empty.585d08d0.svg";